/**
 * #listings_svc.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { Listing } from "../common/common_msg.js";
import { GetBestRequest, GetByIdRequest, GetCommentsRequest, GetDuplicatesRequest, GetHotRequest, GetNewRequest, GetRisingRequest, GetSortRequest, ListingResponse, } from "./listings_msg.js";
export const ListingsServiceName = "devvit.plugin.redditapi.listings.Listings";
export class ListingsClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || ListingsServiceName;
        this.rpc = rpc;
        this.Best = this.Best.bind(this);
        this.ById = this.ById.bind(this);
        this.Comments = this.Comments.bind(this);
        this.Duplicates = this.Duplicates.bind(this);
        this.Hot = this.Hot.bind(this);
        this.New = this.New.bind(this);
        this.Rising = this.Rising.bind(this);
        this.Sort = this.Sort.bind(this);
    }
    Best(request, metadata) {
        const data = GetBestRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Best", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    ById(request, metadata) {
        const data = GetByIdRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ById", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    Comments(request, metadata) {
        const data = GetCommentsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Comments", data, metadata);
        return promise.then((data) => ListingResponse.decode(_m0.Reader.create(data)));
    }
    Duplicates(request, metadata) {
        const data = GetDuplicatesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Duplicates", data, metadata);
        return promise.then((data) => ListingResponse.decode(_m0.Reader.create(data)));
    }
    Hot(request, metadata) {
        const data = GetHotRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Hot", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    New(request, metadata) {
        const data = GetNewRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "New", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    Rising(request, metadata) {
        const data = GetRisingRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Rising", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
    Sort(request, metadata) {
        const data = GetSortRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Sort", data, metadata);
        return promise.then((data) => Listing.decode(_m0.Reader.create(data)));
    }
}
export const ListingsDefinition = {
    name: "Listings",
    fullName: "devvit.plugin.redditapi.listings.Listings",
    methods: {
        /**
         * Home listing
         *
         * @see {@link https://www.reddit.com/dev/api#GET_best}
         */
        best: {
            name: "Best",
            requestType: GetBestRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            82,
                            18,
                            80,
                            47,
                            98,
                            101,
                            115,
                            116,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * Create a custom listing with the Post IDs provided
         *
         * @see {@link https://www.reddit.com/dev/api#GET_by_id_\{names\}}
         */
        byId: {
            name: "ById",
            requestType: GetByIdRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            24,
                            18,
                            22,
                            47,
                            98,
                            121,
                            95,
                            105,
                            100,
                            47,
                            123,
                            112,
                            111,
                            115,
                            116,
                            95,
                            105,
                            100,
                            115,
                            125,
                            46,
                            106,
                            115,
                            111,
                            110,
                        ]),
                    ],
                },
            },
        },
        /**
         * Get a comment tree for a Post
         *
         * @see {@link https://www.reddit.com/dev/api#GET_comments_\{article\}}
         * Note: reddit API returns this in an array of listings. Generated code can't handle this.
         */
        comments: {
            name: "Comments",
            requestType: GetCommentsRequest,
            requestStream: false,
            responseType: ListingResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            143,
                            1,
                            18,
                            140,
                            1,
                            47,
                            99,
                            111,
                            109,
                            109,
                            101,
                            110,
                            116,
                            115,
                            47,
                            123,
                            97,
                            114,
                            116,
                            105,
                            99,
                            108,
                            101,
                            125,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            99,
                            111,
                            109,
                            109,
                            101,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            109,
                            109,
                            101,
                            110,
                            116,
                            125,
                            38,
                            99,
                            111,
                            110,
                            116,
                            101,
                            120,
                            116,
                            61,
                            123,
                            99,
                            111,
                            110,
                            116,
                            101,
                            120,
                            116,
                            125,
                            38,
                            100,
                            101,
                            112,
                            116,
                            104,
                            61,
                            123,
                            100,
                            101,
                            112,
                            116,
                            104,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            111,
                            114,
                            116,
                            61,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            38,
                            116,
                            104,
                            114,
                            101,
                            97,
                            100,
                            101,
                            100,
                            61,
                            123,
                            116,
                            104,
                            114,
                            101,
                            97,
                            100,
                            101,
                            100,
                            125,
                            38,
                            116,
                            114,
                            117,
                            110,
                            99,
                            97,
                            116,
                            101,
                            61,
                            123,
                            116,
                            114,
                            117,
                            110,
                            99,
                            97,
                            116,
                            101,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                    ],
                },
            },
        },
        /**
         * Find duplicate posts that reference the same URL as this Post
         *
         * @see {@link https://www.reddit.com/dev/api#GET_duplicates_\{article\}}
         * Note: reddit API returns this in an array of listings. Generated code can't handle this.
         */
        duplicates: {
            name: "Duplicates",
            requestType: GetDuplicatesRequest,
            requestStream: false,
            responseType: ListingResponse,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            153,
                            1,
                            18,
                            150,
                            1,
                            47,
                            100,
                            117,
                            112,
                            108,
                            105,
                            99,
                            97,
                            116,
                            101,
                            115,
                            47,
                            123,
                            97,
                            114,
                            116,
                            105,
                            99,
                            108,
                            101,
                            125,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            111,
                            114,
                            116,
                            61,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            38,
                            115,
                            114,
                            61,
                            123,
                            115,
                            114,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            99,
                            114,
                            111,
                            115,
                            115,
                            112,
                            111,
                            115,
                            116,
                            115,
                            95,
                            111,
                            110,
                            108,
                            121,
                            61,
                            123,
                            99,
                            114,
                            111,
                            115,
                            115,
                            112,
                            111,
                            115,
                            116,
                            115,
                            95,
                            111,
                            110,
                            108,
                            121,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                        new Uint8Array([2, 64, 1]),
                    ],
                },
            },
        },
        /**
         * Listing with Hot sort
         *
         * @see {@link https://www.reddit.com/dev/api#GET_hot}
         */
        hot: {
            name: "Hot",
            requestType: GetHotRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            101,
                            18,
                            99,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            104,
                            111,
                            116,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            103,
                            61,
                            123,
                            103,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * Listing with New sort
         *
         * @see {@link https://www.reddit.com/dev/api#GET_new}
         */
        new: {
            name: "New",
            requestType: GetNewRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            95,
                            18,
                            93,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            110,
                            101,
                            119,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * Listing with Rising sort
         *
         * @see {@link https://www.reddit.com/dev/api#GET_rising}
         */
        rising: {
            name: "Rising",
            requestType: GetRisingRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            98,
                            18,
                            96,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            114,
                            105,
                            115,
                            105,
                            110,
                            103,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                        ]),
                    ],
                },
            },
        },
        /**
         * Listing with Top or Controversial sort
         *
         * @see {@link https://www.reddit.com/dev/api#GET_\{sort\}}
         */
        sort: {
            name: "Sort",
            requestType: GetSortRequest,
            requestStream: false,
            responseType: Listing,
            responseStream: false,
            options: {
                _unknownFields: {
                    480010: [
                        new Uint8Array([5, 10, 3, 71, 69, 84]),
                        new Uint8Array([
                            104,
                            18,
                            102,
                            47,
                            114,
                            47,
                            123,
                            115,
                            117,
                            98,
                            114,
                            101,
                            100,
                            100,
                            105,
                            116,
                            125,
                            47,
                            123,
                            115,
                            111,
                            114,
                            116,
                            125,
                            46,
                            106,
                            115,
                            111,
                            110,
                            63,
                            97,
                            102,
                            116,
                            101,
                            114,
                            61,
                            123,
                            97,
                            102,
                            116,
                            101,
                            114,
                            125,
                            38,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            61,
                            123,
                            98,
                            101,
                            102,
                            111,
                            114,
                            101,
                            125,
                            38,
                            108,
                            105,
                            109,
                            105,
                            116,
                            61,
                            123,
                            108,
                            105,
                            109,
                            105,
                            116,
                            125,
                            38,
                            99,
                            111,
                            117,
                            110,
                            116,
                            61,
                            123,
                            99,
                            111,
                            117,
                            110,
                            116,
                            125,
                            38,
                            115,
                            104,
                            111,
                            119,
                            61,
                            123,
                            115,
                            104,
                            111,
                            119,
                            125,
                            38,
                            116,
                            61,
                            123,
                            116,
                            125,
                        ]),
                    ],
                },
            },
        },
    },
};
